import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import EveThemeProvider from '@ashn/eve-themes-react/EveThemeProvider';
import { HelmetProvider } from 'react-helmet-async';
import mswStarterLogic from './utils/mswStarterLogic';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
mswStarterLogic().then(() =>
	root.render(
		<QueryClientProvider client={new QueryClient()}>
			<HelmetProvider>
				<React.StrictMode>
					<EveThemeProvider themeKey='internal' themeMode='light'>
						<CssBaseline />
						<App />
					</EveThemeProvider>
				</React.StrictMode>
			</HelmetProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	)
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
